export const en = {
  // common
  email: 'Email',
  password: 'Password',
  name: 'Name',
  cancel: 'Cancel',
  continue: 'Continue',
  or: 'or',
  useDifferentEmail: 'Use a different email',
  somethingWrong: 'Something went wrong',
  code6: '6-digit code',
  resetCode: 'Reset code',
  newPassword: 'New password',
  continueWithGoogle: 'Continue with Google',
  continueWithApple: 'Continue with Apple',
  continueWithEmail: 'Continue with email',
  back: 'Back',

  // sign-in router
  chooserTitle: 'Sign in or create your account',
  chooserSubtitle: 'Choose how you want to continue',
  emailTitle: 'Continue with email',
  emailSubtitle: 'Enter your email to continue',
  welcomeBack: 'Welcome back',
  signIn: 'Sign in',
  forgotPassword: 'Forgot password?',
  createTitle: 'Create your account',
  createAccount: 'Create account',
  confirmTitle: 'Confirm your email',
  confirmCta: 'Confirm & sign in',
  resendCode: 'Resend code',
  confirmNeeded: 'This email needs confirmation. Enter the code we sent you.',
  confirmCodeSent: 'We emailed you a 6-digit confirmation code.',
  codeResent: 'Code resent.',
  googleTitle: 'Use Google to sign in',
  isGoogleAccount: 'is a Google account',
  appleTitle: 'Use Apple to sign in',
  isAppleAccount: 'is an Apple account',
  googleNotConfigured: 'Google sign-in is not configured',
  resetTitle: 'Reset your password',
  resetSubtitle: 'We’ll email you a reset code',
  sendResetCode: 'Send reset code',
  resetCodeSent: 'We emailed you a reset code.',
  setNewTitle: 'Set a new password',
  setNewPassword: 'Set new password',
  passwordUpdated: 'Password updated. Sign in with your new password.',

  // profile
  yourAccount: 'Your account',
  signOut: 'Sign out',
  changePicture: 'Change picture',
  uploading: 'Uploading…',
  preferredLanguage: 'Preferred language',
  saveChanges: 'Save changes',
  saved: 'Saved',
  passwordSection: 'Password',
  changePassword: 'Change password',

  // avatar crop
  adjustPhoto: 'Adjust your photo',
  cropHint: 'Drag to reposition · scroll or pinch to zoom.',
  savePhoto: 'Save photo',
  cropExportError: 'Could not export the cropped image. Try another picture.',

  // callback
  missingCode: 'Missing authorization code or verifier',
  backToSignIn: 'Back to sign in',
  signInFailed: 'Sign-in failed',

  // logout
  signedOutTitle: 'Signed out',
  signedOutBody: "You've been signed out of your WeApps account on this device.",
  goingBackIn: 'Taking you back in {{n}}s…',
  returnToApp: 'Go back',

  // authenticating
  signingIn: 'Signing you in…',
  signingInSubtitle: 'This will only take a moment.',

  // delete account (ISSUE-2026-07-20-240, ADR 0091) — web-reachable deletion for Play/App Store compliance
  deleteTitle: 'Delete your account',
  deleteIntro:
    'You can delete your WeApps account here, from the web, without opening the app. This affects your account across the whole platform.',
  deleteButton: 'Delete account',
  deleteConfirmTitle: 'Delete your account permanently?',
  deleteConfirmBody:
    'This ends your access and removes your account across all organizations, groups, and courses on every device — your sign-in stops working everywhere. Where the law requires it (for example, financial records of past purchases), some data is kept in de-identified form. This action is permanent and cannot be undone.',
  deleteConfirmCta: 'Yes, delete my account',
  deleteKeepCta: 'Keep my account',
  deleteError: "We couldn't schedule the deletion. Please try again.",
  deleteDoneTitle: 'Account scheduled for deletion',
  deleteDoneBody:
    'Your account has been scheduled for deletion and your access is now disabled. Signing in is no longer possible.',
  deleteDoneCta: 'Done',

  // layout / language names
  footer: 'WeApps account',
  language: 'Language',
  langEn: 'English',
  langPt: 'Português',
  langDe: 'Deutsch',
}

export type Strings = typeof en
